import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';

import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/zoom_client_jwt`;

export const ACTION_TYPES = {
  FETCH_ZOOM_JWT_LIST: 'zoom/FETCH_ZOOM_JWT_LIST',
  FETCH_ZOOM_JWT: 'zoom/FETCH_ZOOM_JWT',
  CREATE_ZOOM_JWT: 'zoom/CREATE_ZOOM_JWT',
  UPDATE_ZOOM_JWT: 'zoom/UPDATE_ZOOM_JWT',
  DELETE_ZOOM_JWT: 'zoom/DELETE_ZOOM_JWT',
  RESET: 'zoom/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
};

// REDUCER
const zoomjwtReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ZOOM_JWT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_ZOOM_JWT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_ZOOM_JWT):
    case REQUEST(ACTION_TYPES.UPDATE_ZOOM_JWT):
    case REQUEST(ACTION_TYPES.DELETE_ZOOM_JWT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_ZOOM_JWT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_ZOOM_JWT):
    case FAILURE(ACTION_TYPES.CREATE_ZOOM_JWT):
    case FAILURE(ACTION_TYPES.UPDATE_ZOOM_JWT):
    case FAILURE(ACTION_TYPES.DELETE_ZOOM_JWT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ZOOM_JWT_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ZOOM_JWT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_ZOOM_JWT):
    case SUCCESS(ACTION_TYPES.UPDATE_ZOOM_JWT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_ZOOM_JWT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default zoomjwtReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_ZOOM_JWT_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_ZOOM_JWT,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ZOOM_JWT,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ZOOM_JWT,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_ZOOM_JWT,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
